<h1 mat-dialog-title>Session Expiring</h1>
<div mat-dialog-content class="dialog-content">
  <p>Your session will expire in <span class="countdown">{{ countdown }}</span> seconds.</p>
  <p>Any unsaved work will be lost.</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onClose()">Close</button>
</div>
